import { render, staticRenderFns } from "./leveranser.vue?vue&type=template&id=4a688d8c&scoped=true"
import script from "./leveranser.vue?vue&type=script&lang=js"
export * from "./leveranser.vue?vue&type=script&lang=js"
import style0 from "./leveranser.vue?vue&type=style&index=0&id=4a688d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a688d8c",
  null
  
)

export default component.exports